export default __webpack_public_path__ + "static/media/2.a70bb4a4.png";